/**
 * Операции над заявкой целиком:
 *  - archiveRequest  — POST /manager/request/archive
 *  - deleteRequest   — DELETE /manager/request/{id}
 *  - exportSpecification — POST-форма /manager/request/export-specification (file download)
 *  - openAddProductsModal — делегирует в глобальный ProductSelectionModal
 *    (мигрируется на <x-product-modal> в Этапе 3.18)
 */

import { apiRequest, APIError } from '../../api.js';

export async function archiveRequest(requestId) {
    try {
        await apiRequest('/manager/request/archive', {
            method: 'POST',
            body: { request_id: requestId },
        });
        window.showToast('success', TOAST_MESSAGES.REQUEST.ARCHIVED);
        window.location.href = '/manager/requests';
    } catch (e) {
        const msg = e instanceof APIError ? e.message : 'Unknown error';
        window.showToast('error', TOAST_MESSAGES.REQUEST.ERROR_ARCHIVING + ': ' + msg);
    }
}

export async function deleteRequest(requestId) {
    try {
        await apiRequest('/manager/request/' + requestId, { method: 'DELETE' });
        window.showToast('success', TOAST_MESSAGES.REQUEST.DELETED);
        window.location.href = '/manager/requests';
    } catch (e) {
        const msg = e instanceof APIError ? e.message : 'Unknown error';
        window.showToast('error', TOAST_MESSAGES.REQUEST.ERROR_DELETING + ': ' + msg);
    }
}

export function exportSpecification() {
    const selectedProducts = [];
    document.querySelectorAll('.product-checkbox:checked').forEach(cb => {
        selectedProducts.push(cb.value);
    });

    if (selectedProducts.length === 0) {
        window.showToast('warning', TOAST_MESSAGES.PRODUCT.SELECT_FOR_EXPORT);
        return;
    }

    const csrf = document.querySelector('meta[name="csrf-token"]')?.content || '';

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/manager/request/export-specification';

    const tokenInput = document.createElement('input');
    tokenInput.type = 'hidden';
    tokenInput.name = '_token';
    tokenInput.value = csrf;
    form.appendChild(tokenInput);

    const productsInput = document.createElement('input');
    productsInput.type = 'hidden';
    productsInput.name = 'products';
    productsInput.value = JSON.stringify(selectedProducts);
    form.appendChild(productsInput);

    document.body.appendChild(form);
    form.submit();
    form.remove();
}

export function openAddProductsModal() {
    const urlParts = window.location.pathname.split('/');
    const requestId = urlParts[urlParts.length - 1];
    const userId = urlParts[urlParts.length - 2];

    if (typeof ProductSelectionModal === 'undefined') {
        console.error('ProductSelectionModal не загружен');
        return;
    }

    ProductSelectionModal.open({
        context: 'manager_request',
        data: {
            requestId,
            userId,
            projectId: window.currentProjectId || null,
            rooms: window.projectRooms || [],
        },
        onSelect(result) {
            addProductToRequest(result);
        },
    });
}

async function addProductToRequest(result) {
    const product = result.product;
    const sizeIndex = result.sizeIndex;
    const requestId = result.data.requestId;

    // Определяем цену для выбранного размера
    let price = product.price;
    if (product.size && sizeIndex !== null && sizeIndex !== '') {
        try {
            const sizes = typeof product.size === 'string' ? JSON.parse(product.size) : product.size;
            if (Array.isArray(sizes) && sizes[sizeIndex]) {
                const sizeData = sizes[sizeIndex];
                if (sizeData.price_from) price = sizeData.price_from;
            }
        } catch (e) {
            console.error('Error parsing size data:', e);
        }
    }

    try {
        await apiRequest('/manager/request/product/add', {
            method: 'POST',
            body: {
                request_id: requestId,
                product_id: product.id,
                size_index: sizeIndex,
                price,
                quantity: 1,
            },
        });
        window.location.reload();
    } catch (e) {
        console.error('Error adding product:', e);
        const msg = e instanceof APIError ? e.message : 'Unknown error';
        window.showToast('error', 'Error adding product: ' + msg);
    }
}
